import * as Sentry from '@sentry/react-native';

import type { LoggerContext, LoggerInterface } from '@/utils/logging/_types';

export function SentryLogger(): LoggerInterface {
  const info = (message: string, context?: LoggerContext) => {
    Sentry.addBreadcrumb({ message, data: context, level: 'info' });
  };

  const debug = (message: string, context?: LoggerContext) => {
    Sentry.addBreadcrumb({ message, data: context, level: 'debug' });
  };

  const warn = (message: string, context?: LoggerContext) => {
    Sentry.addBreadcrumb({ message, data: context, level: 'warning' });
  };

  const error = (message: string, context?: LoggerContext) => {
    if (context && context.error && context.error instanceof Error) {
      const { error: caputedError, ...rest } = context;

      Sentry.captureException(caputedError, { extra: rest });
    } else {
      const _error = new Error(message);

      if (_error.stack) {
        const stackLines = _error.stack.split('\n');
        if (stackLines.length > 5) {
          // Remove Logger stack trace since is not useful
          _error.stack = stackLines.slice(6).join('\n');
        }
      }

      Sentry.captureException(_error, { extra: context });
    }
  };

  return Object.freeze({
    info,
    debug,
    warn,
    error,
  });
}
